<template>
  <div id="app">
      <v-modal v-show="isModalVisible" @close="closeModal"/>
      <v-nav v-if="this.$route.name !== 'Home'" />
      <vue-page-transition name="fade" class="animate__animated animate__fadeIn animate__delay-1s">
        <router-view/>
      </vue-page-transition>
      <footer>
        <p class="body-sm">&copy; 2024 &hearts; Made with love by the bride & groom</p>
        <p class="body-sm">Photography by <a href="https://www.ninamarinphoto.com/" target="_blank" rel="noopener noreferrer">Nina Marin</a></p>
      </footer>
  </div>
</template>

<script>
import Modal from '@/components/Modal.vue';
import Nav from '@/components/Nav'

export default {
  components: {
    'v-nav': Nav,
    'v-modal': Modal
    },
    computed: {
      isModalVisible() {
        return this.$store.getters.modalVisible
      }
    },
    methods: {
      closeModal() {
        this.$store.dispatch('toggleModal', false, { root: true })
      }
    }
}
</script>

<style lang="scss">
@import '@/styles/base.scss';

footer {
  align-items: center;
  border-top: $border-900-md;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: $space-3;
  text-align: center;

  p {
    margin: calc(#{$space-1}/4);
  }
}
</style>
